import type { FontOption } from '@/types/properties';
import { ColorPicker, FontStyle, FontSize, FontFamily } from '../shape.map';
import type { DynamicComponentProps } from '@/types/commontypes';
import type { FC } from 'react';
import TextColorIcon from '@/assets/svg/text_color_icon.svg';
import styles from '../../../styles/global.module.css';

const FontOptionComponent: FC<DynamicComponentProps<FontOption>> = ({ label, value, onChange, isFromMiniToolbar }) => {
  const handleChange = (key: string, newValue: string | number) => {
    onChange({ ...value, [key]: newValue });
  };

  const content = (
    <>
      <ColorPicker
        value={value.fill}
        onChange={(color: string) => handleChange('fill', color)}
        isFromMiniToolbar={isFromMiniToolbar}
        svgIcon={TextColorIcon}
      />
      {!isFromMiniToolbar && (
        <FontFamily
          value={value.fontFamily}
          onChange={(fontFamily: string) => handleChange('fontFamily', fontFamily)}
        />
      )}
      <FontSize value={value.fontSize} onChange={(fontSize: number) => handleChange('fontSize', fontSize)} />

      {!isFromMiniToolbar && (
        <>
          <FontStyle
            value={value.fontStyle}
            onChange={(fontStyle: string) => handleChange('fontStyle', fontStyle)}
            availableStyles={[
              {
                style: 'italic',
                label: <em>I</em>,
              },
            ]}
          />
          <FontStyle
            value={String(value.fontWeight)}
            onChange={(fontWeight: string | number) => handleChange('fontWeight', fontWeight)}
            availableStyles={[
              {
                style: 'bold',
                label: value.fontWeight === 'bold' ? <strong>B</strong> : <h3>B</h3>,
              },
            ]}
          />
        </>
      )}
    </>
  );

  if (isFromMiniToolbar) {
    return <div className="flex items-center gap-2">{content}</div>;
  }

  return (
    <div className={label ? styles.property_rows : ''} style={{ gridColumn: label ? undefined : 'span 2' }}>
      <label className={styles.property_label}>{label}</label>
      <div className={styles.property_value}>{content}</div>
    </div>
  );
};

export default FontOptionComponent;
